import { Link } from 'theme-ui';
import { useTranslation } from 'next-i18next';
import theme from '@styles/theme';
import { TSocialMedia } from '@features/footer/typescript';
import styles from '@features/footer/Footer.styles';
import Icon from '@components/icons/Icon';
import { firstUppercase } from '@utils/misc';
import { TIcon } from '@components/icons/typescript';
type PropsType = {
  media: TSocialMedia[];
};
const SocialMedia = ({
  media
}: PropsType) => {
  const {
    t
  } = useTranslation('layouts');
  const iconColor = theme.rawColors.neutralBlack;
  return <div sx={styles.footerMediaContainer}>
      {!!media && media.map((item: TSocialMedia) => <Link key={item.icon} href={item.link} rel="noreferrer" target="_blank" title={`${item.icon} ${t('footer.links.opensInNewWindow')}`}>
            <div sx={styles.footerMediaLink}>
              <Icon icon={firstUppercase(item.icon) as TIcon} size="32px" color={iconColor} title={item.icon} />
            </div>
          </Link>)}
    </div>;
};
export default SocialMedia;